import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum OperatorPermissionFilterFormErrorStatesEnum {
    UpdateOperatorPermissionFilterFailed = ErrorStateScheduleEnum.OperatorPermissionFilterFormStatesStartIndex,
}
